'use client';

import React from 'react';
import { LucideIcon } from 'lucide-react';
import styles from './ServiceTabs.module.css';

export interface TabItem {
    id: string;
    label: string;
    icon: LucideIcon;
}

interface ServiceTabsProps {
    tabs: TabItem[];
    activeTabId: string;
    onTabClick: (id: string) => void;
}

export const ServiceTabs = ({ tabs, activeTabId, onTabClick }: ServiceTabsProps) => {
    return (
        <div className={styles.tabsContainer}>
            {tabs.map((tab) => {
                const isActive = tab.id === activeTabId;
                const Icon = tab.icon;

                const buttonClasses = [styles.tabButton, isActive ? styles.active : '']
                    .join(' ')
                    .trim();

                return (
                    <button
                        key={tab.id}
                        className={buttonClasses}
                        onClick={() => onTabClick(tab.id)}
                        aria-pressed={isActive}
                    >
                        <Icon className={styles.tabIcon} />
                        <span className={styles.tabLabel}>{tab.label}</span>
                    </button>
                );
            })}
        </div>
    );
};
